// Entry of the page. The visible part of the line (header, prefs, «О модуле», Code-and-Key window, picker, their
// styles) is the shared kit on our host (code-reuse kit/README.md), not a copy in this bundle. Its address is the
// contour's, not the build's: the server writes an import map for `@frigat/kit` and a meta tag with the channel base
// into index.html from its `.env` (server/kitBase.ts) — one bundle serves stage and prod.
//
// Neither part of the kit may hold the page: kit.css is linked from here (a <link> in <head> would block the module
// scripts while the kit host hangs) and the application is imported dynamically — both under one timeout. The loader
// FAILS CLOSED: no kit.css or no kit.js — one line of text (bootGate.ts), not a screen without styles.
import { browserLang, renderBootMessage } from './bootGate.ts';

const KIT_TIMEOUT_MS = 10000;

/** The channel base the server wrote into the page (`<meta name="frigat-kit-base">`). */
function kitBase(): string | null {
  return document.querySelector<HTMLMetaElement>('meta[name="frigat-kit-base"]')?.content || null;
}

/** kit.css goes FIRST in <head>: the module's own styles follow it and win at equal weight. */
function loadKitCss(base: string, timeoutMs: number): Promise<boolean> {
  return new Promise((resolve) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${base}kit.css`;
    const timer = setTimeout(() => resolve(false), timeoutMs);
    link.onload = () => {
      clearTimeout(timer);
      resolve(true);
    };
    link.onerror = () => {
      clearTimeout(timer);
      resolve(false);
    };
    document.head.prepend(link);
  });
}

async function start(): Promise<void> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(new Error('kit timeout')), KIT_TIMEOUT_MS);
  });
  let app: typeof import('./main.ts');
  // Each part names itself on failure: in the console a kit.js that did not load and the module's own chunk that did
  // not load both read «Failed to fetch dynamically imported module …main-*.js» otherwise. The person sees one line
  // either way — «the module interface did not load» is true for both.
  const tagged = <T>(part: string, p: Promise<T>): Promise<T> =>
    p.catch((e: unknown) => {
      throw new Error(`${part}: ${String(e)}`);
    });
  try {
    const base = kitBase();
    if (!base) throw new Error('no kit channel in the page (<meta name="frigat-kit-base">)');
    const [cssOk, , loaded] = await Promise.all([
      loadKitCss(base, KIT_TIMEOUT_MS),
      Promise.race([tagged(`kit.js (${base}kit.js)`, import('@frigat/kit')), timeout]),
      // main.ts imports `@frigat/kit` too: the module graph is fetched once, this only waits for the module's chunk.
      Promise.race([tagged('module chunk', import('./main.ts')), timeout]),
    ]);
    if (!cssOk) throw new Error(`kit.css did not load: ${base}kit.css`);
    app = loaded;
  } catch (e) {
    console.error('[staff-handover] the module interface did not load —', e instanceof Error ? e.message : e);
    const root = document.getElementById('app') ?? document.body;
    renderBootMessage(root, 'kit', browserLang(navigator.language));
    return;
  } finally {
    clearTimeout(timer);
  }
  // Outside the try: a failure of the running module (after both parts loaded) is not a loading failure and must not
  // be reported as one. A failure while the module chunk itself loads stays above, named «module chunk».
  void app.startApp();
}

void start();
